// @ts-nocheck
import React, { FC } from 'react';
import cn from 'classnames';

import Text from 'crehana-ui/Text';

import { IconProps } from 'crehana-icons/types';

interface FeatureProps {
  Icon: React.ComponentType<IconProps>;
  title: string;
  desc: string;
  className?: string;
}

const Feature: FC<FeatureProps> = ({ Icon, title, desc, className }) => (
  <div
    className={cn(
      'flex flex-col md:flex-row items-center justify-center',
      className,
    )}
  >
    <Icon size={48} className="mb-16 md:mb-0 md:mr-16" />
    <div className="flex flex-col text-center md:text-left">
      <Text type="subtitle3" className="mb-4">
        {title}
      </Text>
      <Text color="gray-dark">{desc}</Text>
    </div>
  </div>
);

export default Feature;
